import React, { useState, useEffect } from "react";
import axios from "axios";
import "./ImageSwapper.css";

const ImageSwapper = () => {
  const [allImages, setAllImages] = useState([]);
  const [displayedImages, setDisplayedImages] = useState([]);
  const [loadedImages, setLoadedImages] = useState({});

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await axios.get(
          "https://kkblossomschool.org/KKBlossomsWebsite/api.php?action=getImages&category=swapper"
        );

        console.log(response.data);

        const imageData = Array.isArray(response.data)
          ? response.data
          : response.data.data || [];

        const images = imageData.map(
          (img) => `https://kkblossomschool.org/KKBlossomsWebsite/uploads/${img.image}`
        );

        setAllImages(images);
        setDisplayedImages(images.slice(0, 5));
      } catch (error) {
        console.error("Error fetching images:", error);
      }
    };

    fetchImages();
  }, []);

  // Rotate every 5 seconds
  useEffect(() => {
    if (displayedImages.length <= 1) return;

    const interval = setInterval(() => {
      setDisplayedImages((prevImages) => {
        const rotated = [...prevImages];
        const first = rotated.shift();
        rotated.push(first);
        return rotated;
      });
    }, 5000);

    return () => clearInterval(interval);
  }, [displayedImages.length]);

  const handleImageLoaded = (src) => {
    setLoadedImages((prev) => ({
      ...prev,
      [src]: true,
    }));
  };

  if (displayedImages.length === 0) {
    return (
      <div className="image-swapper-page-loader">
        <div className="image-spinner"></div>
      </div>
    );
  }

  return (
    <div className="images-swapper-wrapper">
      <div className="image-swapper-container">
        {displayedImages.map((img, index) => (
          <div key={index} className="image-swapper-box">
            {!loadedImages[img] && (
              <div className="image-loader">
                <div className="image-spinner"></div>
              </div>
            )}

            <img
              src={img}
              alt={`img-${index}`}
              onLoad={() => handleImageLoaded(img)}
              style={{
                display: loadedImages[img] ? "block" : "none",
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageSwapper;